import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import useRoleHooks from "@/shared/hooks/useRoleHooks";
import { DeliveryMethods, Sources } from "@/shared/utils/enum";
import { asArray } from "@/shared/utils/helpers";
import { IUserSettings } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

export const userSettingsSources = [
  {
    label: "WEBSITE AND APP",
    value: [
      Sources.WEBSITE,
      Sources.IOS_WEB_APP,
      Sources.ANDROID_WEB_APP,
      Sources.IOS_NATIVE_APP,
      Sources.ANDROID_NATIVE_APP,
    ],
  },
  { label: "THUISBEZORGD_NL", value: [Sources.THUISBEZORGD_NL] },
  { label: "UBER_EATS", value: [Sources.UBER_EATS] },
  { label: "HOMIE", value: [Sources.HOMIE] },
  { label: "POS", value: [Sources.POS] },
  { label: "qrTableOrder", value: [Sources.QR] },
];

const userSettingsDeliveryMethods = [
  { label: "delivery", value: [DeliveryMethods.DELIVERY] },
  { label: "takeAway", value: [DeliveryMethods.TAKEAWAY] },
  { label: "posOrder", value: [DeliveryMethods.POS_ORDER] },
  {
    label: "deliveryByExternal",
    value: [DeliveryMethods.DELIVERY_BY_EXTERNAL],
  },
  {
    label: "qrTableOrder",
    value: [DeliveryMethods.QR_TABLE_ORDER],
  },
  {
    label: "dinein",
    value: [DeliveryMethods.DINE_IN],
  },
];

const useUserSettingsQuery = () => {
  const { hasAuthority, getRoles } = useRoleHooks();
  const branch = useBranchId();
  return useQuery<IUserSettings>({
    queryKey: ["userSettings", branch],
    queryFn: () => get2(`/internal/secure/pos/v2/user/settings/${branch}`),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled:
      branch !== undefined &&
      !getRoles.isPending &&
      hasAuthority("ROLE_ORDER_TRACKER_WRITE"),
    select: (data) => {
      return {
        ...data,
        sources: asArray(
          data?.sources ?? userSettingsSources.map((s) => s.value).flat()
        ),
        delivery_methods: asArray(
          data?.delivery_methods ??
            userSettingsDeliveryMethods.map((s) => s.value).flat()
        ),
      };
    },
  });
};

export default useUserSettingsQuery;
